// Import base components
import { httpV2 } from "../http.js";

const AnnouncementsService = {
  listAnnouncements: () => httpV2.get(`/announcements`),

  dismissAnnouncement: (user_id, announcement_id) =>
    httpV2.put(`/announcements/dismiss`, { user_id, announcement_id }),
};

export default AnnouncementsService;
